"use client";
import React, { useState, useEffect } from "react";
import AppLogo from "@/components/ui/AppLogo";
import { useRouter } from "next/navigation";

export default function Header() {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-linen/95 backdrop-blur-md shadow-sm py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <AppLogo
          size={36}
          text="The Halal Estates"
          onClick={() => router?.push("/")}
          className="cursor-pointer"
        />

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-pine-light">
          {[
            { label: "Properties", href: "#properties" },
            { label: "Services", href: "#services" },
            { label: "Process", href: "#process" },
            { label: "About", href: "#process" },
            { label: "FAQ", href: "#faq" },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              className="relative hover:text-pine transition-colors duration-200 after:absolute after:bottom-[-3px] after:left-0 after:w-0 after:h-px after:bg-amber after:transition-all after:duration-300 hover:after:w-full"
            >
              {item?.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden md:inline-flex items-center gap-2 bg-amber text-linen text-sm font-medium px-5 py-2.5 rounded-full hover:bg-amber-hover transition-colors duration-300"
        >
          Book Consultation
        </a>

        {/* Mobile menu button */}
        <button className="md:hidden flex flex-col gap-1.5 p-2" aria-label="Menu">
          <span className="w-5 h-0.5 bg-pine rounded" />
          <span className="w-4 h-0.5 bg-pine rounded" />
          <span className="w-5 h-0.5 bg-pine rounded" />
        </button>
      </div>
    </header>
  );
}